import { PropsWithChildren, SyntheticEvent, useContext, useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, Switch, ToolbarButton, ToolbarDivider, ToolbarGroup, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
    InfoRegular
} from "@fluentui/react-icons";
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import { usePPA } from "context/ppa-context";
import { IApiError } from "@interfaces/common.interfaces";
import { getError } from "lib/utils";
import { IAppApplicationRoleMembershipDialogProps } from "./add-application-role-membership-dialog.props";
import MultiObjectPicker from "components/controls/multi-object-picker/multi-object-picker";
import ApiErrorBar from "components/common/api-error-bar/api-error-bar";


export default function AppApplicationRoleMembershipDialog(props: IAppApplicationRoleMembershipDialogProps) {
    const { t } = useL10n<ILocaleStrings>();
    const { getApiClient } = usePPA();
    const [open, setOpen] = useState<boolean>(false);
    const [apiError, setApiError] = useState<IApiError | null>(null);

    const [allMemberUsers, setAllMemberUsers] = useState<boolean>(false);
    const [members, setMembers] = useState<Array<any>>([]);

    useEffect(() => {
        setOpen(props.isOpen);
    }, [props.isOpen]);

    const onOpenChange = (event: SyntheticEvent, data: { open: boolean }) => {
        props.isOpenCallback(data.open);
    }

    const onSubmit = async () => {
        // Convert the principalType to memberType for submitting.

        const memberDtos = members.map((member) => { return { ...member, memberType: member.principalType } });

        if (allMemberUsers) {
            memberDtos.push({ memberType: 8 });
        }

        setApiError(null);
        getApiClient()
            // .post(props.apiUrl, [{ upn: "tome@6bqzvs.onmicrosoft.com", memberType: 1 }, { memberType: 0, displayName: "Low Level Group" }])
            .post(props.apiUrl, memberDtos)
            .then(
                (response) => {
                    //resolve(response.data);
                    props.onSuccess();
                },
                (error) => {
                    setApiError(getError(error));
                    //resolve(error);
                });
    };

    return (
        <Dialog
            modalType="alert"
            open={open}
            onOpenChange={onOpenChange}>
            <DialogSurface>
                <DialogBody>
                    <DialogTitle>{t("ppaApplicationRoleMembershipAddTitle")}</DialogTitle>
                    <DialogContent >
                        <div dangerouslySetInnerHTML={{ __html: t("ppaApplicationRoleMembershipAddMessage") }}></div>
                        <Switch
                            label={t('ppaAllowAllMemberUsers')}
                            checked={allMemberUsers}
                            onChange={() => { setAllMemberUsers(!allMemberUsers) }} />
                        <MultiObjectPicker
                            onChange={setMembers}
                            label="principalPickerUserOrGroupLabel"
                            principalTypes={["User", "Group"]} />
                        <ApiErrorBar
                            error={apiError} />
                    </DialogContent>
                    <DialogActions>
                        <Button
                            appearance="primary"
                            onClick={onSubmit}>{t("ok")}</Button>
                        <DialogTrigger disableButtonEnhancement>
                            <Button appearance="secondary">{t("cancel")}</Button>
                        </DialogTrigger>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
}